// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1981":"abc438a4","3098":"53daba9e","3675":"be02d858","4759":"8a6b9e2a","9467":"ebc26391"}[chunkId] + ".chunk.css";
};